export * from './post.component';
